import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { UserLogin } from 'graphql/generated';

const initialState: {
  token: string;
  user: UserLogin | null;
} = {
  token: '',
  user: null,
};

export const AuthStore = signalStore(
  {
    providedIn: 'root'
  },
  withState(initialState),
  withMethods((store) => ({
    set(data: { token: string, user: UserLogin }): void{
      patchState(store, (s) => {
        if (!data) return s;
        
        return data;
      });
    },
  }))
);
